import React from 'react';
import { UpcomingPaymentsProps } from '../../types/invoice.types';

const UpcomingPayments: React.FC<UpcomingPaymentsProps> = ({ payments }) => {
  // Helper function to format currency
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div className="mt-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Upcoming Payments</h3>
      <div className="space-y-4">
        {payments.map((payment, index) => (
          <div key={index} className="bg-white rounded-lg shadow p-4">
            <div className="flex justify-between">
              <div>
                <div className="text-gray-700">{payment.date}: {payment.client}</div>
              </div>
              <div className="font-medium text-gray-800">
                {formatCurrency(payment.amount)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingPayments;